import { AppRoutes } from './router';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
